import { Text, View } from "components/ui";
import React from "react";
import { StyleSheet } from "react-native";
import Modal from "react-native-modal";
interface Props {
	isSheetOpen: boolean;
	toggleSheet: () => void;
	children: React.ReactNode;
}
const SlideSheet = ({ toggleSheet, isSheetOpen, children }: Props) => {
	return (
		<Modal propagateSwipe={true} style={styles.bottomModal} onBackdropPress={toggleSheet} animationIn={"slideInUp"} animationOut={"slideOutDown"} isVisible={isSheetOpen}>
			<View style={styles.modalContent}>
				{children}
				{/* <Text>You Clicked On Modal !</Text> */}
			</View>
		</Modal>
	);
};

export default SlideSheet;

const styles = StyleSheet.create({
	modalContent: {
		backgroundColor: "white",
		padding: 22,
		justifyContent: "center",
		alignItems: "center",
		borderRadius: 4,
	},
	bottomModal: {
		justifyContent: "flex-end",
		margin: 0,
	},
});
